import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Badge, Modal, ModalBody, ModalHeader } from "reactstrap";
import BulkUploadResult from "../Components/BulkUploadResult";
import FileDropZone from "../Components/FileDropZone";
import SelectedFileCard from "../Components/SelectedFileCard";
import useBulkUpload from "../Hooks/useBulkUpload";
import { BULK_UPLOAD_MESSAGES } from "../Json/BulkUploadMessages";
import { clearSelectedUploadType } from "../../../../slices/bulkOrder/bulkOrderSlice";
import { editModal, openModal } from "../../../../slices/common/reducer";

const { modal } = BULK_UPLOAD_MESSAGES;
const DROPZONE_INPUT_PREFIX = "bulk-upload-file";

/**
 * Upload modal for the bulk type chosen in the listing.
 *
 * Follows the same contract as the other Settings modals: visibility comes
 * from state.common.modalShow and closing resets both that flag and the
 * screen's own selection.
 */
const NewBulkUploadModal = () => {
  const dispatch = useDispatch();
  const modalShow = useSelector((state) => state.common.modalShow);
  const config = useSelector((state) => state.bulkOrder.selectedUploadType);

  const { file, isUploading, result, error, selectFile, clearFile, upload } =
    useBulkUpload(config);

  const handleClose = () => {
    if (isUploading) return;

    dispatch(openModal(false));
    dispatch(editModal(false));
    dispatch(clearSelectedUploadType());
  };

  if (!config) return null;

  return (
    <Modal
      isOpen={modalShow}
      centered
      size="lg"
      className="border-0"
      modalClassName="modal fade zoomIn"
      toggle={handleClose}
    >
      <ModalHeader className="p-3 bg-info-subtle" toggle={handleClose}>
        <span className="me-2">{config.title}</span>
        <Badge color={config.badge.color} className="fw-medium">
          {config.badge.text}
        </Badge>
      </ModalHeader>

      <ModalBody className="p-4">
        <p className="text-muted">{config.description}</p>

        <FileDropZone
          inputId={`${DROPZONE_INPUT_PREFIX}-${config.id}`}
          disabled={isUploading}
          onFileSelected={selectFile}
        />

        {file && (
          <SelectedFileCard
            file={file}
            isUploading={isUploading}
            onRemove={clearFile}
            onUpload={upload}
          />
        )}

        {error && (
          <div
            className="alert alert-danger d-flex align-items-start mt-3 mb-0"
            role="alert"
          >
            <i className="ri-close-circle-line me-2 mt-1" />
            <div>{error}</div>
          </div>
        )}

        {result && <BulkUploadResult result={result} />}

        {!file && !result && !error && (
          <p className="text-muted font-size-12 text-center mt-3 mb-0">
            {modal.hint}
          </p>
        )}
      </ModalBody>
    </Modal>
  );
};

export default NewBulkUploadModal;
